var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Video_Call"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Video_Call",
    "data-name": "Video Call",
    clipPath: "url(#clip-Video_Call)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-call_15213841",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M62.818,6H17.364A11.364,11.364,0,0,0,6,17.364V94.636A11.364,11.364,0,0,0,17.364,106H62.818A11.315,11.315,0,0,0,68,104.753a26.1,26.1,0,0,1-9.506-16.935H10.545V17.364a6.818,6.818,0,0,1,6.818-6.818h3.6l6.761,6.761a7.955,7.955,0,0,0,5.625,2.33H46.828a7.955,7.955,0,0,0,5.625-2.33l6.761-6.761h3.6A6.821,6.821,0,0,1,69.251,15.1,11.364,11.364,0,0,0,58.273,26.455v14.61a8.165,8.165,0,0,0,8.173,8.117,3.188,3.188,0,0,1,3.191,3.169v8.221a2.273,2.273,0,0,0,4.545,0V55.207a3.313,3.313,0,0,0,.382-.22l7.564-5.043a4.545,4.545,0,0,1,2.521-.763h9.987A11.364,11.364,0,0,0,106,37.818V26.455A11.364,11.364,0,0,0,94.636,15.091H73.955A11.368,11.368,0,0,0,62.818,6ZM52.786,10.545h-.195v.2ZM67.364,26.455a2.273,2.273,0,1,0,0,4.545H85.545a2.273,2.273,0,1,0,0-4.545ZM65.091,37.818a2.273,2.273,0,0,1,2.273-2.273H96.909a2.273,2.273,0,0,1,0,4.545H67.364A2.273,2.273,0,0,1,65.091,37.818Z",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M70,78.818h6.818V72H70Z",
    transform: "translate(8.727 9)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M80,74.539v2.45l2.273.653V73.886Z",
    transform: "translate(10.091 9.257)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M67.364,58.571A21.6,21.6,0,1,0,77.591,56,21.66,21.66,0,0,0,67.364,58.571Zm0,23.565a3.409,3.409,0,0,0,3.409,3.409h9.091A3.406,3.406,0,0,0,82.72,84l3.021.868a3.409,3.409,0,0,0,4.35-3.277V74.816a3.409,3.409,0,0,0-4.35-3.277l-2.556.734a3.41,3.41,0,0,0-3.321-2.637H70.773a3.409,3.409,0,0,0-3.409,3.409Z",
    transform: "translate(6.818 6.818)",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M37.364,50.727A11.364,11.364,0,1,0,26,39.364,11.364,11.364,0,0,0,37.364,50.727Z",
    transform: "translate(2.727 3)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M20,63.364A11.364,11.364,0,0,1,31.364,52H45A11.364,11.364,0,0,1,56.364,63.364v3.409a7.955,7.955,0,0,1-7.955,7.955H27.955A7.955,7.955,0,0,1,20,66.773Z",
    transform: "translate(1.909 6.273)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.b4f9243b61d86a41181511ecee1e6178.svg";
export { ForwardRef as ReactComponent };